// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"079adaabbb289ff04bca","339":"c34e368c32c8fb766c63"}[chunkId] + ".js";
};